module.exports = __webpack_public_path__ + "static/media/SarahSwitek_02_HowAreYouFeeling_2.d8571093.mp3";